import {AfterViewInit, ChangeDetectionStrategy, Component, TemplateRef, ViewChild, inject} from '@angular/core';
import {ButtonModule} from 'primeng/button';

import {TLabel, TranslatePipe} from '@mydeals/i18n';

import {ModalSeverity, ModalSize} from './modal-config.model';
import {ModalRef} from './modal-ref';

/** Payload consumed by {@link ConfirmModal}; built by `ModalService.confirm()`. */
export interface ConfirmModalData {
  readonly message: TLabel;
  readonly messageParams?: Record<string, unknown>;
  readonly confirmLabel: TLabel;
  readonly cancelLabel: TLabel;
  readonly confirmSeverity: ConfirmSeverity;
}

export type ConfirmSeverity = 'danger' | 'contrast';

/** Public options for `ModalService.confirm()`. Only `message` is required. */
export interface ConfirmOptions {
  readonly message: TLabel;
  readonly messageParams?: Record<string, unknown>;
  readonly title?: TLabel;
  readonly icon?: string;
  readonly severity?: ModalSeverity;
  /** Confirm button color; follows `severity` unless set (a red badge over a black button). */
  readonly confirmSeverity?: ConfirmSeverity;
  readonly confirmLabel?: TLabel;
  readonly cancelLabel?: TLabel;
  readonly size?: ModalSize;
}

@Component({
  selector: 'crm-confirm-modal',
  imports: [ButtonModule, TranslatePipe],
  templateUrl: './confirm-modal.html',
  styleUrl: './confirm-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmModal implements AfterViewInit {
  private readonly modalRef = inject<ModalRef<boolean, ConfirmModalData>>(ModalRef);

  @ViewChild('footerTpl', {static: true}) footerTpl!: TemplateRef<unknown>;

  protected readonly data = this.modalRef.data!;

  ngAfterViewInit(): void {
    this.modalRef.setFooter(this.footerTpl);
  }

  confirm(): void {
    this.modalRef.close(true);
  }

  cancel(): void {
    this.modalRef.close(false);
  }
}
